// FILLED gating tables — Detection Engine System 1 (spec §3.3).
//
// Какие cells §V Catalog имеют написанную карточку (positive) vs дыра → F-stub.
// Re-synced против live Section C 2026-06-18 (kickoff-бриф: дельты нет; snapshot
// каталога = 2026-06-12). Verify-долг §7 — при правке Section C обновить здесь.

import { LAYER_TO_ABBR } from './layers.js';

const pairKey = (a, b) => [a, b].sort().join('|');

// PARALLEL_WHOLE_FILLED (16): V+Se, V+G, V+A, V+Y, Se+A, Se+W, Se+L, G+A, G+W,
// G+Y, G+L, A+W, A+Y, W+Y, W+L, Y+L.
const PW_FILLED = new Set(
  [
    ['Vitality', 'Security'], ['Vitality', 'Growth'], ['Vitality', 'Authorship'],
    ['Vitality', 'Yourself'], ['Security', 'Authorship'], ['Security', 'Wanting'],
    ['Security', 'Lasting'], ['Growth', 'Authorship'], ['Growth', 'Wanting'],
    ['Growth', 'Yourself'], ['Growth', 'Lasting'], ['Authorship', 'Wanting'],
    ['Authorship', 'Yourself'], ['Wanting', 'Yourself'], ['Wanting', 'Lasting'],
    ['Yourself', 'Lasting'],
  ].map(([a, b]) => pairKey(a, b)),
);

// LATE_CONVERGENCE_FILLED: Se+Y, Y+L.
const LATE_CONV_FILLED = new Set(
  [['Security', 'Yourself'], ['Yourself', 'Lasting']].map(([a, b]) => pairKey(a, b)),
);

// DIVERGENCE_FILLED = ∅ (divergence всегда → F.2).
// CURRENT_SINGLETON_FILLED: все 7 → всегда positive.
const HISTORICAL_FILLED = new Set(['Authorship']);
const LAST_TO_COLLAPSE_FILLED = new Set(['Wanting']);
const VSHAPE_FILLED = new Set(['Security', 'Yourself']);
const SINGLETON_CYCLING_FILLED = new Set(['Lasting']);

export const FILLED = {
  parallelWhole: (a, b) => PW_FILLED.has(pairKey(a, b)),
  lateConvergence: (a, b) => LATE_CONV_FILLED.has(pairKey(a, b)),
  divergence: () => false,
  currentSingleton: () => true,
  historical: (L) => HISTORICAL_FILLED.has(L),
  lastToCollapse: (L) => LAST_TO_COLLAPSE_FILLED.has(L),
  firstToCollapse: () => false, // нет filled-cells → всегда F.3
  drifting: () => false, // нет filled-cells → всегда F.3
  vShape: (L) => VSHAPE_FILLED.has(L),
  cycling: (L) => SINGLETON_CYCLING_FILLED.has(L),
  tripletAsOne: () => true, // SPARSE_GROUP A.3.1
  groupVsGroup: () => true, // SPARSE_GROUP A.3.2
  fieldLevel: () => true, // PAGE_LEVEL A.4.2
};

/** Аббревиатура слоя для логов/cell-id. */
export const abbr = (L) => LAYER_TO_ABBR[L];
